<template>
  <div>
    <template v-if="this.data != null">
      <template v-if="this.user.roles[0] != 'EC_USER'">
        <template v-if="$vuetify.breakpoint.mdAndUp">
          <BottomNavigationControl :mppt="data.mppt" :dab="data.battery.batteries" />
        </template>

        <template v-if="$vuetify.breakpoint.smAndDown">
          <BottomNavigationControl :mppt="data.mppt" :dab="data.battery.batteries" :panel="false" />
        </template>
      </template>

      <v-row>
        <v-col cols="12" align="center">
          <h3>{{ $t("powerplant.total.header") }}</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4" align="center">
          <ApexGradientDonutChart :data="donutData" :label="donutLabel" :width="donutMaxWidth" :dark="$vuetify.theme.dark" :header="$t('powerplant.donut')" />
        </v-col>

        <v-col align="center">
          <CardUnit
            :cardMaxWidth="cardMaxWidth"
            :cardName="$t('home.solar.name')"
            unitName="PV"
            :stateValue="data.pv.state != '' ? $t('variableValues.state.' + data.pv.state.replace('ERR_', '')) : ''"
            :stateText="$t('home.solar.state')"
            :stateTooltip="data.pv.state"
            topRightText
            :topRightValue="data.pv.status.search(/SolarsReady/gi) == -1 ? 1 : 0"
            :statusValue="data.pv.energyControlStatus1"
            statusText=""
            :errorValue="data.pv.error1 != '' ? $t('variableValues.error.' + data.pv.error1) : ''"
            :errorText="$t('home.solar.error')"
            :errorTooltip="data.pv.error1"
            :powerText="$t('home.solar.power')"
            :powerValue="data.pv.powerOut"
            :energyHeader1="$t('home.solar.today')"
            :energyHeader2="$t('home.solar.yesterday')"
            :energy1Text="$t('home.solar.produced')"
            :energy1Value="data.pv.energyToday"
            :energy3Text="$t('home.solar.produced')"
            :energy3Value="data.pv.energyYesterday"
            :value1Value="data.pv.uIn"
            value1Text="V"
            :value2Value="data.pv.iIn"
            value2Text="A"
            :value3Value="0"
            value3Text
            :value4Text="data.pv.powerOut > 0 ? $t('home.solar.desc1') : ''"
            :gaugeColor="gaugeColorPV"
            :gaugeValue="data.pv.powerOut"
            :gaugeValueMax="gaugeValueMax"
          ></CardUnit>
        </v-col>
        <v-col cols="12" md="4" align="center">
          <v-row>
            <v-col cols="12">
              <h4>{{ $t("powerplant.chart.header") }}</h4>
            </v-col>
            <v-col cols="12">
              <template v-if="this.lineChartData != null">
                <div class="caption"><v-avatar color="red" size="8"></v-avatar> {{ $t("powerplant.chart.max") }}: {{ this.lineChartDataMax }} kW <br /></div>
              </template>
              <AdvancedSparkLine :data="this.lineChartData" :gradient="['red', 'orange', 'yellow']" />
              <template v-if="this.lineChartData != null">
                <div class="caption"><v-avatar color="yellow" size="8"></v-avatar> {{ $t("powerplant.chart.min") }}: {{ this.lineChartDataMin }} kW</div>
              </template>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" align="center">
          <h3>{{ this.$t("powerplant.detail.header") }}</h3>
        </v-col>

        <v-col cols="12">
          <v-slide-group show-arrows="always" active-class="success" center-active>
            <v-row justify="center" class="ma-4">
              <v-slide-item v-for="(item, index) in data.mppt" :key="index" class="mx-4">
                <CardUnit
                  :cardMaxWidth="cardMaxWidth"
                  :cardName="index + 1 + ') ' + $t('powerplant.cardName.' + ('type' in item ? item.type : 'sun'))"
                  :unitName="'type' in item ? item.type : 'sun'"
                  :stateValue="item.state != '' ? $t('variableValues.state.' + item.state.replace('ERR_', '')) : ''"
                  :stateText="$t('home.solar.state')"
                  :stateTooltip="item.state"
                  topRightText
                  :topRightValue="item.status.search(/SolarsReady/gi) == -1 ? 1 : 0"
                  :statusValue="item.energyControlStatus1"
                  statusText=""
                  :errorValue="item.error1 != '' ? $t('variableValues.error.' + item.error1) : ''"
                  :errorText="$t('home.solar.error')"
                  :errorTooltip="item.error1"
                  :powerText="$t('home.solar.power')"
                  :powerValue="item.powerOut"
                  :energyHeader1="$t('home.solar.today')"
                  :energyHeader2="$t('home.solar.yesterday')"
                  :energy1Text="$t('home.solar.produced')"
                  :energy1Value="item.energyToday"
                  :energy3Text="$t('home.solar.produced')"
                  :energy3Value="item.energyYesterday"
                  :value1Value="item.uIn"
                  value1Text="V"
                  :value2Value="item.iIn"
                  value2Text="A"
                  :value3Value="0"
                  value3Text
                  :value4Text="item.powerOut > 0 ? $t('home.solar.desc1') : ''"
                  :gaugeColor="item.type == 'wind' ? gaugeColorWind : gaugeColorSun"
                  :gaugeValue="item.powerOut"
                  :gaugeValueMax="gaugeValueMax"
                ></CardUnit>
              </v-slide-item>
            </v-row>
          </v-slide-group>
        </v-col>
      </v-row>

      <v-row>
        <!--       <v-col offset="2" cols="4">
        <AdvancedSparkLine :data="testData" />
      </v-col> -->

        <!--       <v-col offset="1" cols="2">
        <ApexGradientDonutChart :data="donutData" :label="donutLabel" />
      </v-col>
 -->
        <!--       <v-col offset="1" cols="4">
        <AdvancedSparkLine />
      </v-col> -->
      </v-row>

      <v-col align="end"> </v-col>
    </template>

    <template v-else>
      <LoadingData />
    </template>

    <UpgradeCore />
  </div>
</template>

<script>
import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";

import CardUnit from "../../components/cards/CardUnit.vue";

import { svgGaugeColors } from "../../colors.js";

import AdvancedSparkLine from "../../components/charts/vuetify/AdvancedSparkLine.vue";
import ApexGradientDonutChart from "../../components/charts/apexcharts/ApexGradientDonutChart.vue";
/*import ApexRealTimeChart2 from "../components/charts/apexcharts/ApexRealTimeChart2.vue";*/
import LoadingData from "../../components/LoadingData.vue";

import BottomNavigationControl from "../../components/navigation/BottomNavigationControl.vue";

import { ServiceClient } from "../../service_client/service_client.js";

export default {
  name: "PowerPlant",
  props: {},
  components: {
    AdvancedSparkLine,
    ApexGradientDonutChart,
    /*ApexRealTimeChart2,*/
    BottomNavigationControl,
    CardUnit,
    LoadingData,
    UpgradeCore,
  },
  data() {
    return {
      timer: null,

      user: JSON.parse(sessionStorage.getItem("user")),

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,

      gaugeValueMax: 15,

      cardMaxWidth: 0,
      donutMaxWidth: 0,

      lineChartData: [],
      lineChartLabel: [],

      lineChartDataMin: 0,
      lineChartDataMax: 0,

      donutData: [],
      donutLabel: [],

      data: null,

      /*       data: {
        pv: {
          type: "sun",
          state: "ON",
          warning: "Reset",
          error1: "",
          error2: "",
          error3: "",
          errors: "",
          status: " READY | SelfTestOK | DCLinkIsCharged | SolarsReady |",
          energyControlStatus1: "",
          hwDiag1: 1,
          hwDiag2: 0,
          hwDiag3: 0,
          hwDiag4: 0,
          uIn: 172.9,
          iIn: 0.95,
          powerIn: 0.17,
          energyIn: 0.0,
          uOut: 398.6,
          iOut: 0.32,
          powerOut: 12,
          energyOut: 8.98,
          energyToday: 3.78,
          energyYesterday: 5.2,
        },
        mppt: [
          {
            id: 1,
            type: "sun",
            state: "ON",
            warning: "Reset",
            error1: "",
            error2: "",
            error3: "",
            errors: "",
            status: " READY | SelfTestOK | DCLinkIsCharged | SolarsReady |",
            energyControlStatus1: "",
            hwDiag1: 1,
            hwDiag2: 0,
            hwDiag3: 0,
            hwDiag4: 0,
            uIn: 172.9,
            iIn: 0.95,
            powerIn: 0.17,
            energyIn: 0.0,
            uOut: 398.6,
            iOut: 0.32,
            powerOut: 4,
            energyOut: 8.98,
            energyToday: 3.78,
            energyYesterday: 5.2,
          },
          {
            id: 2,
            type: "sun",
            state: "ON",
            warning: "Reset",
            error1: "",
            error2: "",
            error3: "",
            errors: "",
            status: " READY | SelfTestOK | DCLinkIsCharged | SolarsReady |",
            energyControlStatus1: "",
            hwDiag1: 1,
            hwDiag2: 0,
            hwDiag3: 0,
            hwDiag4: 0,
            uIn: 172.9,
            iIn: 0.95,
            powerIn: 0.17,
            energyIn: 0.0,
            uOut: 398.6,
            iOut: 0.32,
            powerOut: 4,
            energyOut: 8.98,
            energyToday: 3.78,
            energyYesterday: 5.2,
          },
          {
            id: 3,
            type: "wind",
            state: "ON",
            warning: "Reset",
            error1: "",
            error2: "",
            error3: "",
            errors: "",
            status: " READY | SelfTestOK | DCLinkIsCharged | SolarsReady |",
            energyControlStatus1: "",
            hwDiag1: 1,
            hwDiag2: 0,
            hwDiag3: 0,
            hwDiag4: 0,
            uIn: 172.9,
            iIn: 0.95,
            powerIn: 0.17,
            energyIn: 0.0,
            uOut: 398.6,
            iOut: 0.32,
            powerOut: 4,
            energyOut: 8.98,
            energyToday: 3.78,
            energyYesterday: 5.2,
          },
        ],
      }, */

      gaugeColorPV: [
        { offset: 0, color: svgGaugeColors.pv[0] },
        { offset: 100, color: svgGaugeColors.pv[1] },
      ],

      gaugeColorSun: [
        { offset: 0, color: svgGaugeColors.sun[0] },
        { offset: 100, color: svgGaugeColors.sun[1] },
      ],

      gaugeColorWind: [
        { offset: 0, color: svgGaugeColors.wind[0] },
        { offset: 100, color: svgGaugeColors.wind[1] },
      ],
    };
  },
  computed: {
    /*     ...mapState({
      account: (state) => state.account,
    }), */
  },
  created() {
    this.getBreakpoints();
    this.getData();
  },
  mounted() {
    this.pollData();

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  methods: {
    onResize() {
      this.getBreakpoints();
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.cardMaxWidth = this.windowWidth - (48 + 24);
        this.donutMaxWidth = this.windowWidth - 48;
        this.mobile = true;
      } else {
        this.cardMaxWidth = 350;
        this.donutMaxWidth = 350;
        this.mobile = false;
      }
    },
    pollData() {
      this.timer = setInterval(() => {
        this.getData();
        this.getDataChart();
      }, 2500);
    },
    getData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("main"), null, null, "GET")
        .then((data) => {
          this.data = data;

          this.donutData = [];
          this.donutLabel = [];

          for (let index = 0; index < this.data.mppt.length; index++) {
            if (this.data.mppt[index].state != "Reset") {
              if (this.data.mppt[index].powerOut < 0) {
                this.data.mppt[index].powerOut = 0;
              }

              this.donutData.push(this.data.mppt[index].powerOut);
              this.donutLabel.push(index + 1 + ") " + this.$i18n.t("powerplant.cardName." + ("type" in this.data.mppt[index] ? this.data.mppt[index].type : "sun")));
            }
          }
        })
        .catch((error) => {
          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    getDataChart() {
      let parameters = "?time=" + "M" + "&type=" + "P" + "&limit=" + "60";

      ServiceClient.dataCore(ServiceClient.getAPIUrl("chart"), null, parameters, "GET")
        .then((data) => {
          this.lineChartData = data.pv;
          this.lineChartLabel = data.labels;

          this.lineChartDataMin = Math.min(...this.lineChartData);
          this.lineChartDataMax = Math.max(...this.lineChartData);
        })
        .catch((error) => {
          this.datacollection = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);

    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped></style>
